<wlm-generic-chart
  *ngIf="genericChartSettings"
  [settings]="genericChartSettings"
  [loadingHandler$]="loadingHandler$"
  [size]="size"
  [disableFixedSize]="disableFixedSize"
  (chartInitEvent)="onChartInit($event)"
  (chartDataZoomEvent)="onChartDataZoom($event)"
  (chartLegendSelectedEvent)="onChartLegendSelected($event)"
  (chartLoaded)="onChartLoaded($event)"
  (chartFinished)="onChartFinished($event)"
></wlm-generic-chart>

<wlm-no-results [showNoResult]="!dataLoaded && !isLoading"> </wlm-no-results>
